module.exports = __webpack_public_path__ + "./img/DestacadosCreacion.7ca52c8a40ae4cac8d4fe186426e7212.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/DestacadosCreacion.png
// module id = ./public/img/Help/DestacadosCreacion.png
// module chunks = 0